import React from "react";
import { StyleSheet, View } from "react-native";

import { buttonStyle } from "../../common/ActionsMenuButton/utils";
import ActionButton from "../../common/ActionsMenuButton/ActionButton";
import AppTheme from "../../AppTheme";
import QuestionIcon from "../../common/ActionsMenuButton/icons/QuestionIcon";
import { getContactMailUrl, openURL } from "../../../../helpers/utils";

export default function IntegrationsBlackListedFabButton({
  mariOptions = {},
  style = {},
}) {
  return (
    <View style={[buttonStyle, style]}>
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"IntegrationsBlacklistFabButton"}
      >
          <ActionButton.Item
              underline
              buttonColor="#FFF"
              title="Help"
              onPress={() => {
                  openURL(getContactMailUrl());
              }}
          >
              <QuestionIcon style={styles.actionButtonIcon} />
          </ActionButton.Item>
      </ActionButton>
    </View>
  );
}
const styles = StyleSheet.create({
    actionButtonIcon: {
        marginTop: 5,
        width: 44,
        height: 44,
    },
});
